import { isEmpty } from 'lodash';
import { useContext, useState } from 'react';
import { FlatList } from 'react-native';
import { Text } from '@shared/components/Text';
import { View } from '@shared/components/View';
import { MBImagePreviewModal } from '@shared/components/image';
import { ColorThemeContext, grid } from '@shared/styles';
import { FileUpload } from '@shared/types/fieldValues';
import { isImage } from '@shared/util/media/type';
import { AuditImageListItem } from './AuditImageListItem';

interface FilesProps {
  files: FileUpload[];
  editable: boolean;
  onRemoved?(file: FileUpload): void;
  maxHeight?: number;
  maxWidth?: number;
  minWidth?: number;
  numImagesToShow?: number;
}

export function AuditImageList({
  files,
  onRemoved,
  editable,
  maxHeight = 200,
  maxWidth = 300,
  minWidth = editable ? grid(16) : grid(4),
  numImagesToShow,
}: FilesProps) {
  const [showPreviewModal, setShowPreviewModal] = useState<boolean>(false);
  const [showIndex, setShowIndex] = useState<number>(0);
  const images = files.filter(file => {
    return isImage(file);
  });

  const extraImagesCount = numImagesToShow ? images.length - numImagesToShow : 0;
  const colors = useContext(ColorThemeContext);
  const imagesToShow =
    extraImagesCount > 0 ? images.splice(0, numImagesToShow ?? images.length) : images;

  if (isEmpty(imagesToShow)) {
    return null;
  }

  return (
    <>
      <View flex style={{ height: maxHeight, flexShrink: 0 }}>
        <FlatList
          keyExtractor={item => {
            return item.url;
          }}
          data={imagesToShow}
          horizontal={true}
          // @ts-expect-error -- strict migration
          ListFooterComponent={
            extraImagesCount > 0 && (
              <View
                center
                flex
                style={{
                  height: maxHeight,
                  width: maxWidth,
                  borderRadius: grid(1),
                  backgroundColor: colors.backgroundInactive,
                }}
                margin={0.5}
                marginLeft={1}
                marginRight={0}
              >
                <Text size="body1" numberOfLines={1}>
                  {'+' + extraImagesCount}
                </Text>
              </View>
            )
          }
          renderItem={image => {
            return (
              <View>
                <AuditImageListItem
                  image={image.item}
                  marginLeft={0}
                  marginRight={image.index === imagesToShow.length - 1 ? 0 : grid(1)}
                  onClear={() => onRemoved?.(image.item)}
                  maxHeight={maxHeight}
                  maxWidth={maxWidth}
                  minWidth={minWidth}
                  editable={editable}
                  onClick={selectedImage => {
                    setShowIndex(images.findIndex(i => i.url === selectedImage.url));
                    setShowPreviewModal(true);
                  }}
                />
              </View>
            );
          }}
        />
      </View>
      {showPreviewModal && (
        <MBImagePreviewModal
          images={images}
          showIndex={showIndex}
          visible={showPreviewModal}
          onClose={() => {
            setShowPreviewModal(false);
          }}
        />
      )}
    </>
  );
}
